<template>
  <div class="passwordChanged">
    <div class="passwordChanged__wrapper">
      <div class="title-img">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="160" height="140" viewBox="0 0 160 140">
          <defs>
              <path id="a" d="M7.292 24.806h5.833c.875 0 1.458-.437 1.458-1.312v-.145c0-8.31 7.146-15.162 15.604-14.579 7.73.583 13.563 7.29 13.563 15.162v-.438c0 .875.583 1.312 1.458 1.312h5.834c.875 0 1.458-.437 1.458-1.312v-.145C52.5 10.082 41.417-.561 28 .023 15.604.606 6.125 11.103 5.833 23.494c.146.73.73 1.312 1.459 1.312zm-1.459-1.312v.584-.584zm52.5 12.975c0-3.207-2.625-5.831-5.833-5.831H5.833C2.625 30.638 0 33.262 0 36.469v27.7C0 67.376 2.625 70 5.833 70H52.5c3.208 0 5.833-2.624 5.833-5.831v-27.7zM35.875 59.358c.292.874-.438 1.895-1.458 1.895H23.77c-1.021 0-1.604-.875-1.459-1.895l2.625-8.747c-2.187-1.458-3.5-4.082-3.062-6.998.583-2.77 2.77-4.957 5.688-5.54 4.666-.875 8.75 2.478 8.75 6.852 0 2.332-1.167 4.52-3.063 5.686l2.625 8.747z"/>
          </defs>
          <g fill="none" fill-rule="evenodd">
              <g transform="translate(20)">
                  <circle cx="70" cy="70" r="70" fill="#E5E5EA"/>
                  <circle cx="70" cy="70" r="58.333" fill="#D5D5DA"/>
                  <use fill="#FFF" transform="rotate(-15 160.355 -105.497)" xlink:href="#a"/>
              </g>
              <g transform="translate(0 50)">
                  <rect width="58" height="24" fill="#5AC8FA" rx="12"/>
                  <path fill="#FFF" d="M3.988 10.392l1.824-3.216 3.632 2.288-.176-4.272h3.712l-.176 4.272 3.632-2.288 1.824 3.216-3.824 2 3.824 2-1.824 3.216-3.632-2.288.176 4.272H9.268l.176-4.272-3.632 2.288-1.824-3.216 3.824-2-3.824-2zm17.59 0L23.4 7.176l3.632 2.288-.176-4.272h3.712l-.176 4.272 3.632-2.288 1.824 3.216-3.824 2 3.824 2-1.824 3.216-3.632-2.288.176 4.272h-3.712l.176-4.272-3.632 2.288-1.824-3.216 3.824-2-3.824-2zm17.589 0l1.824-3.216 3.632 2.288-.176-4.272h3.712l-.176 4.272 3.632-2.288 1.824 3.216-3.824 2 3.824 2-1.824 3.216-3.632-2.288.176 4.272h-3.712l.176-4.272-3.632 2.288-1.824-3.216 3.824-2-3.824-2z"/>
              </g>
          </g>
      </svg>
      </div>
      <div class="content">
        <h2 class="small-title">Awesome!</h2>
        <h2 class="small-title text">your password has been changed</h2>
        <p class="subhead description">your new password saved successfuly. now you can access your account using your new password.</p>
        <button type="button" class="btn-large btn-block primary" @click.stop="signIn">Sign in to continue</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-password-changed',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    signIn() {
      this.$router.push({name: 'signin'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>